import _objectDestructuringEmpty from "@babel/runtime-corejs3/helpers/objectDestructuringEmpty";import _extends from "@babel/runtime-corejs3/helpers/extends";import React from 'react';
import ZipCode from "../../ZipCode";


var ZipCodeOption = function ZipCodeOption(_ref) {var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/(
    React.createElement("div", null, /*#__PURE__*/
    React.createElement(ZipCode, props)));


};

export default ZipCodeOption;
//# sourceMappingURL=index.js.map